import { FilterStatement as Statement } from './datagram';
import { Guà } from './hexagram';

export type FilterType = 'Lines' | 'And' | 'Or';

type Filter = {
  /** Possibly defined lines to 7 or 8 values to match hexagrams */
  type: 'Lines';
  /** The hexagram lines statement */
  lines: Statement;
};

export const empty = (): Filter => ({
  type: 'Lines',
  lines: Array.from({ length: 6 }, () => undefined)
});

export const hasSome = (filter?: Filter) =>
  filter &&
  filter.type === 'Lines' &&
  filter.lines &&
  filter.lines.some((i) => {
    return i === 7 || i === 8;
  });

export const isEmpty = (filter?: Filter) => !hasSome(filter);

export const label = (value?: Filter) =>
  (value && hasSome(value) && JSON.stringify(value.lines)) || undefined;

const match = (lines: Statement, filtered: Statement) => {
  // filtered: [undefined, 7, 7, 7, 7, 8]
  // lines:    [        7, 7, 7, 7, 7, 7]
  const matched = lines.filter(
    (value, index) =>
      index > filtered.length || !filtered[index] || value === filtered[index]
  );
  return matched.length === 6;
};

export const filtered = (hexagrams: Guà[], value?: Filter): Guà[] => {
  // @todo filter type
  return (
    (value &&
      hexagrams.filter((hexagram) => match(hexagram.lines, value.lines))) ||
    hexagrams
  );
};

export default Filter;
